import { render } from "./GeoContenutoLang.vue?vue&type=template&id=51d08289"
import script from "./GeoContenutoLang.vue?vue&type=script&lang=js"
export * from "./GeoContenutoLang.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__